import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Stack,
  Button,
  Container,
  Typography,
} from '@mui/material';

import { ThemeProvider } from '@mui/material/styles';
import Theme from '../../components/Button';

// components
import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
// mock
import EditarUsuarioForm from '../FormsTemplates/Usuario/EditarUsuarioForms';

export default function AlterarDespesa() {
  
  return (
    <Page title="Usuário">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Alterar Usuário
          </Typography>
          <ThemeProvider theme={Theme}>
            <Button variant="contained" color="neutral" component={RouterLink} to="/usuarios/consultar" startIcon={<Iconify icon="eva:arrow-back-fill" />}>
              Voltar
            </Button>
          </ThemeProvider>
        </Stack>
        <EditarUsuarioForm/>    
      </Container>
    </Page>
  );
}
